import immutable from 'immutable'
import { FLEETDRIVERINFO } from '../actiontype'
const defaultState = immutable.fromJS({
    //接单数
    driverAcceptOrder : 0,
    //取消数
    driverCancelOrder : 0,
    //司机名字
    driverName :'',
    //在线时长
    onlineTime : 0,
    //是否为队长
    isCaptain : false,
    //流水 
    payableAmount : 0,
    // 奖励金额
    rewardAmount :0,
    // 是否在线
    status : 0,
    // 车队长
    captainName : '',
    // 车队长电话：
    captainPhone : ''
})

export const fleetdriverinfoReducer = (state = defaultState, action) => {
    switch (action.type) {
        case FLEETDRIVERINFO:
            return state.updateIn(['driverAcceptOrder'], _ => (action.data.driverAcceptOrder))
                        .updateIn(['driverCancelOrder'],_ => (action.data.driverCancelOrder))
                        .updateIn(['driverName'],_ => (action.data.driverName))
                        .updateIn(['onlineTime'],_ => (action.data.onlineTime))
                        .updateIn(['isCaptain'],_ => (action.data.isCaptain))
                        .updateIn(['payableAmount'],_ => (action.data.payableAmount))
                        .updateIn(['captainName'],_ => (action.data.captainName))
                        .updateIn(['captainPhone'],_ => (action.data.captainPhone))
                        .updateIn(['status'],_ => (action.data.status))
                        .updateIn(['rewardAmount'],_ => (action.data.rewardAmount))
                        

        default:
            break;
    }
    return state
}
